import { formatPercentage } from '@cast/utils';

import { WORKLOAD_RECOMMENDATION_MIN_CONFIDENCE } from 'features/workload-optimization/constants';

import { getRangeToConfidence } from './utils';

import { Typography, tokens } from '@cast/design-system';

type Props = {
  reachedAt: string;
};

export const ThresholdReachedAtLabel = (props: Props) => {
  const [number, units] = getRangeToConfidence(props.reachedAt);

  return (
    <Typography
      variant="L10M"
      color={tokens.theme.fg.structural.secondary}
      data-testid="time-to-confidence"
    >
      ≈ {number} {units}to reach{' '}
      {formatPercentage(WORKLOAD_RECOMMENDATION_MIN_CONFIDENCE * 100)}
    </Typography>
  );
};
